import { unique } from '../utils/helper';

export default class PriceHelper {
  seven_days = [
    { count: 1, type: 'breakfast', price: '300' },
    { count: 1, type: 'lunch', price: '300' },
    //{ count: 1, type: 'brunch', price: '300' },
    { count: 1, type: 'dinner', price: '300' },
    { count: 3, type: 'breakfast', price: '550', sale: 40 },
    { count: 3, type: 'lunch', price: '550', sale: 40  },
    //{ count: 3, type: 'brunch', price: '550', sale: 40  },
    { count: 3, type: 'dinner', price: '550', sale: 40  },
    { count: 6, type: 'breakfast', price: '700', sale: 60 },
    { count: 6, type: 'lunch', price: '700', sale: 60 },
    //{ count: 6, type: 'brunch', price: '700', sale: 60 },
    { count: 6, type: 'dinner', price: '700', sale: 60 },
    { count: 12, type: 'breakfast', price: '950', sale: 75 },
    { count: 12, type: 'lunch', price: '950', sale: 75 },
    //{ count: 12, type: 'brunch', price: '950', sale: 75 },
    { count: 12, type: 'dinner', price: '950', sale: 75 },
  ]
  five_days = [
    { count: 1, type: 'breakfast', price: '200' },
    { count: 1, type: 'lunch', price: '200' },
    //{ count: 1, type: 'brunch', price: '200' },
    { count: 1, type: 'dinner', price: '200' },
    { count: 3, type: 'breakfast', price: '350', sale: 40  },
    { count: 3, type: 'lunch', price: '350', sale: 40  },
    //{ count: 3, type: 'brunch', price: '350', sale: 40  },
    { count: 3, type: 'dinner', price: '350', sale: 40  },
    { count: 6, type: 'breakfast', price: '500', sale: 60 },
    { count: 6, type: 'lunch', price: '500', sale: 60 },
    //{ count: 6, type: 'brunch', price: '500', sale: 60 },
    { count: 6, type: 'dinner', price: '500', sale: 70 },
    { count: 12, type: 'breakfast', price: '750', sale: 70 },
    { count: 12, type: 'lunch', price: '750', sale: 70 },
    //{ count: 12, type: 'brunch', price: '750', sale: 70 },
    { count: 12, type: 'dinner', price: '750', sale: 70 },
  ]

  current_day = null;
  current_count = null;
  current_promo = null;

  current_types = [];

  constructor(meal_types, days_count) {
    this.current_types = meal_types;
    this.current_day = days_count;
  }

  getPrices() {
    const currentPrices = this.current_day == 5 ? this.five_days : this.seven_days;
    let res = currentPrices
      .filter(el => this.current_types.includes(el.type))

    res = res.map(el => {
      el.full_price = el.price * res.filter(r => r.count === el.count).length
      if (this.current_promo) {
        el.full_price -= el.full_price * (this.current_promo / 100)
        el.price -= el.price * (this.current_promo / 100)

        el.full_price = ~~el.full_price
        el.price = ~~el.price
      }
      return el;
    })

    res = res.map(el => {
        return {
          ...el,
          ...this.getCurrentTitles(el)
        }
      })

    return unique(res, 'count');
  }

  applyPromo(promo) {
    promo = promo.toUpperCase();
    if (promo === 'KITCHEN10') this.current_promo = 10;
    if (promo === 'KITCHEN20') this.current_promo = 20
    return true;
  }

  getCurrentTitles(el) {
    if (el.count === 1) {
      return {
        title: `${el.full_price}р за месяц`,
        subtitle: `пн-вс`,
      }
    } else if (el.count === 12) {
      return {
        title: `${el.full_price}р за год`,
        subtitle: `${~~(el.full_price / el.count)}р за один месяц`,
      }
    } else {
      return {
        title: `${el.full_price}р за ${el.count} месяца`,
        subtitle: `${~~(el.full_price / el.count)}р за один месяц`,
      }
    }
  }

}
